import { Component } from '@angular/core';

@Component({
  selector: 'app-decreto',
  standalone: true,
  imports: [],
  templateUrl: './decreto.component.html',
  styleUrl: './decreto.component.css'
})
export class DecretoComponent {

}
